module.exports = __webpack_public_path__ + "static/bg.5e522405.png";